import { BagSliceState } from './bag.slice.interfaces';

export const initialState: BagSliceState = {
  order: null,
  isLoading: false,
  createdDate: null,
};
